import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSignatureFieldsByFileApprovalIdQueryVariables = Types.Exact<{
  fileApprovalId: Types.Scalars['String'];
}>;


export type GetSignatureFieldsByFileApprovalIdQuery = { __typename?: 'Query', getSignatureFieldsByFileApprovalId: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldLeftPercentage?: number | null, fieldTopPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null, fieldId?: string | null, fieldType: Types.FieldType, createAt: any, updateAt: any, completedAt?: any | null, fileApprovalId: string, signatureImage?: string | null, title?: string | null, description?: string | null }> };

export type GetFileApprovalQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetFileApprovalQuery = { __typename?: 'Query', fileApproval: { __typename?: 'FileApprovalEntity', id: string, expiresAt: any, fileRequestId: string, email: string, name: string, kbaEnable: boolean, completedAt?: any | null, createAt: any, updateAt: any, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldLeftPercentage?: number | null, fieldTopPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null, fieldId?: string | null, fieldType: Types.FieldType, createAt: any, updateAt: any }> | null, KBA?: Array<{ __typename?: 'KbaEntity', id: string, numKbaAttempts?: number | null, numKbaFailedAttempts?: number | null, numRequestedIdScans?: number | null, numFailedIdScans?: number | null, fileApprovalId?: string | null, type: Types.KbaType, isIdScanPassed: boolean, isIdScanPending: boolean, isValidated: boolean, createAt: any, updateAt: any, KBAFields?: Array<{ __typename?: 'KBAFieldEntity', id: string, value?: string | null, type: Types.QuestionType }> | null }> | null, FileRequests?: { __typename?: 'FileRequestEntity', id: string, userId?: string | null, firmAccountId?: string | null, clientId?: string | null, notes?: string | null, title?: string | null, compiledHash?: string | null, signedFileId?: string | null, compiledFileId?: string | null, taxYearInterviewId: string, taskId?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, createAt: any, updateAt: any, FileApprovals?: Array<{ __typename?: 'FileApprovalEntity', id: string, expiresAt: any, fileRequestId: string, email: string, name: string, kbaEnable: boolean, completedAt?: any | null, createAt: any, updateAt: any, SignatureFields?: Array<{ __typename?: 'SignatureFieldEntity', id: string, page?: number | null, fieldLeftPercentage?: number | null, fieldTopPercentage?: number | null, fieldWidthPercentage?: number | null, fieldHeightPercentage?: number | null, fieldType: Types.FieldType, createAt: any, updateAt: any }> | null }> | null, CompiledFile?: { __typename?: 'FileEntity', s3Key?: string | null, name?: string | null, id: string } | null, TaxYearInterview?: { __typename?: 'TaxYearInterviewEntity', id: string, taxYearId: string, preparedId?: string | null, reviewedId?: string | null, notes?: string | null, assignedAt: any, completedAt?: any | null, reviewStatus?: Types.ReviewStatus | null, preparerAcceptedAt?: any | null, createAt: any, updateAt: any, Tasks?: Array<{ __typename?: 'TaskEntity', id: string, taxYearInterviewId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any }> | null } | null, SignedFile?: { __typename?: 'FileEntity', s3Key?: string | null } | null } | null } };

export type GetSignedFileByS3KeyQueryVariables = Types.Exact<{
  s3Key: Types.Scalars['String'];
}>;


export type GetSignedFileByS3KeyQuery = { __typename?: 'Query', SignedFileByS3Key: string };

export type GetSignedFileByFileIdQueryVariables = Types.Exact<{
  fileId: Types.Scalars['String'];
}>;


export type GetSignedFileByFileIdQuery = { __typename?: 'Query', SignedFileByFileId: string };


export const GetSignatureFieldsByFileApprovalIdDocument = gql`
    query GetSignatureFieldsByFileApprovalId($fileApprovalId: String!) {
  getSignatureFieldsByFileApprovalId(fileApprovalId: $fileApprovalId) {
    id
    page
    fieldLeftPercentage
    fieldTopPercentage
    fieldWidthPercentage
    fieldHeightPercentage
    fieldId
    fieldType
    createAt
    updateAt
    completedAt
    fileApprovalId
    signatureImage
    title
    description
  }
}
    `;

/**
 * __useGetSignatureFieldsByFileApprovalIdQuery__
 *
 * To run a query within a React component, call `useGetSignatureFieldsByFileApprovalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignatureFieldsByFileApprovalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignatureFieldsByFileApprovalIdQuery({
 *   variables: {
 *      fileApprovalId: // value for 'fileApprovalId'
 *   },
 * });
 */
export function useGetSignatureFieldsByFileApprovalIdQuery(baseOptions: Apollo.QueryHookOptions<GetSignatureFieldsByFileApprovalIdQuery, GetSignatureFieldsByFileApprovalIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignatureFieldsByFileApprovalIdQuery, GetSignatureFieldsByFileApprovalIdQueryVariables>(GetSignatureFieldsByFileApprovalIdDocument, options);
      }
export function useGetSignatureFieldsByFileApprovalIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignatureFieldsByFileApprovalIdQuery, GetSignatureFieldsByFileApprovalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignatureFieldsByFileApprovalIdQuery, GetSignatureFieldsByFileApprovalIdQueryVariables>(GetSignatureFieldsByFileApprovalIdDocument, options);
        }
export type GetSignatureFieldsByFileApprovalIdQueryHookResult = ReturnType<typeof useGetSignatureFieldsByFileApprovalIdQuery>;
export type GetSignatureFieldsByFileApprovalIdLazyQueryHookResult = ReturnType<typeof useGetSignatureFieldsByFileApprovalIdLazyQuery>;
export type GetSignatureFieldsByFileApprovalIdQueryResult = Apollo.QueryResult<GetSignatureFieldsByFileApprovalIdQuery, GetSignatureFieldsByFileApprovalIdQueryVariables>;
export const GetFileApprovalDocument = gql`
    query GetFileApproval($id: String!) {
  fileApproval(id: $id) {
    id
    expiresAt
    fileRequestId
    email
    name
    kbaEnable
    completedAt
    createAt
    updateAt
    SignatureFields {
      id
      page
      fieldLeftPercentage
      fieldTopPercentage
      fieldWidthPercentage
      fieldHeightPercentage
      fieldId
      fieldType
      createAt
      updateAt
    }
    KBA {
      id
      numKbaAttempts
      numKbaFailedAttempts
      numRequestedIdScans
      numFailedIdScans
      fileApprovalId
      type
      isIdScanPassed
      isIdScanPending
      isValidated
      createAt
      updateAt
      KBAFields {
        id
        value
        type
      }
    }
    FileRequests {
      id
      userId
      firmAccountId
      clientId
      notes
      title
      compiledHash
      signedFileId
      compiledFileId
      taxYearInterviewId
      taskId
      signatureRequest
      signatureComplete
      createAt
      updateAt
      FileApprovals {
        id
        expiresAt
        fileRequestId
        email
        name
        kbaEnable
        completedAt
        createAt
        updateAt
        SignatureFields {
          id
          page
          fieldLeftPercentage
          fieldTopPercentage
          fieldWidthPercentage
          fieldHeightPercentage
          fieldType
          createAt
          updateAt
        }
      }
      CompiledFile {
        s3Key
        name
        id
      }
      TaxYearInterview {
        id
        taxYearId
        preparedId
        reviewedId
        notes
        assignedAt
        completedAt
        reviewStatus
        preparerAcceptedAt
        createAt
        updateAt
        Tasks {
          id
          taxYearInterviewId
          taskType
          completedAt
          deletedAt
          createAt
          updateAt
        }
      }
      SignedFile {
        s3Key
      }
    }
  }
}
    `;

/**
 * __useGetFileApprovalQuery__
 *
 * To run a query within a React component, call `useGetFileApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileApprovalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetFileApprovalQuery, GetFileApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileApprovalQuery, GetFileApprovalQueryVariables>(GetFileApprovalDocument, options);
      }
export function useGetFileApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileApprovalQuery, GetFileApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileApprovalQuery, GetFileApprovalQueryVariables>(GetFileApprovalDocument, options);
        }
export type GetFileApprovalQueryHookResult = ReturnType<typeof useGetFileApprovalQuery>;
export type GetFileApprovalLazyQueryHookResult = ReturnType<typeof useGetFileApprovalLazyQuery>;
export type GetFileApprovalQueryResult = Apollo.QueryResult<GetFileApprovalQuery, GetFileApprovalQueryVariables>;
export const GetSignedFileByS3KeyDocument = gql`
    query GetSignedFileByS3Key($s3Key: String!) {
  SignedFileByS3Key(s3Key: $s3Key)
}
    `;

/**
 * __useGetSignedFileByS3KeyQuery__
 *
 * To run a query within a React component, call `useGetSignedFileByS3KeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedFileByS3KeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedFileByS3KeyQuery({
 *   variables: {
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useGetSignedFileByS3KeyQuery(baseOptions: Apollo.QueryHookOptions<GetSignedFileByS3KeyQuery, GetSignedFileByS3KeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedFileByS3KeyQuery, GetSignedFileByS3KeyQueryVariables>(GetSignedFileByS3KeyDocument, options);
      }
export function useGetSignedFileByS3KeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedFileByS3KeyQuery, GetSignedFileByS3KeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedFileByS3KeyQuery, GetSignedFileByS3KeyQueryVariables>(GetSignedFileByS3KeyDocument, options);
        }
export type GetSignedFileByS3KeyQueryHookResult = ReturnType<typeof useGetSignedFileByS3KeyQuery>;
export type GetSignedFileByS3KeyLazyQueryHookResult = ReturnType<typeof useGetSignedFileByS3KeyLazyQuery>;
export type GetSignedFileByS3KeyQueryResult = Apollo.QueryResult<GetSignedFileByS3KeyQuery, GetSignedFileByS3KeyQueryVariables>;
export const GetSignedFileByFileIdDocument = gql`
    query GetSignedFileByFileId($fileId: String!) {
  SignedFileByFileId(fileId: $fileId)
}
    `;

/**
 * __useGetSignedFileByFileIdQuery__
 *
 * To run a query within a React component, call `useGetSignedFileByFileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedFileByFileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedFileByFileIdQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetSignedFileByFileIdQuery(baseOptions: Apollo.QueryHookOptions<GetSignedFileByFileIdQuery, GetSignedFileByFileIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedFileByFileIdQuery, GetSignedFileByFileIdQueryVariables>(GetSignedFileByFileIdDocument, options);
      }
export function useGetSignedFileByFileIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedFileByFileIdQuery, GetSignedFileByFileIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedFileByFileIdQuery, GetSignedFileByFileIdQueryVariables>(GetSignedFileByFileIdDocument, options);
        }
export type GetSignedFileByFileIdQueryHookResult = ReturnType<typeof useGetSignedFileByFileIdQuery>;
export type GetSignedFileByFileIdLazyQueryHookResult = ReturnType<typeof useGetSignedFileByFileIdLazyQuery>;
export type GetSignedFileByFileIdQueryResult = Apollo.QueryResult<GetSignedFileByFileIdQuery, GetSignedFileByFileIdQueryVariables>;
export const namedOperations = {
  Query: {
    GetSignatureFieldsByFileApprovalId: 'GetSignatureFieldsByFileApprovalId',
    GetFileApproval: 'GetFileApproval',
    GetSignedFileByS3Key: 'GetSignedFileByS3Key',
    GetSignedFileByFileId: 'GetSignedFileByFileId'
  }
}